import styled from "styled-components/native";

export const StyledGrid = styled.View`
  display: flex;
  align-self: center;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
  width: 90%;
  max-width: 2000px;
`;
